module.exports = __webpack_public_path__ + "static/media/book-user.3945b98a.svg";